import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HealthService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}`;


  buscarHealthApi(url: string): Observable<any>{
    const headers = new HttpHeaders();

    return this.http.get<any>(`${url}`, { headers });
  }

}
